export default __webpack_public_path__ + "static/media/H521119.95950d1e.jpg";